import React from 'react';
export function SchemaMarkup() {
  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'ai.web - Website Design Dublin',
    image: 'https://aiwebsitepackage.com/og-image.jpg',
    description: 'Affordable professional website design for Dublin businesses. €249 launch package including hosting, support, and AI editing.',
    priceRange: '€150-€499',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Dublin',
      addressCountry: 'IE'
    },
    areaServed: {
      '@type': 'City',
      name: 'Dublin'
    },
    url: 'https://aiwebsitepackage.com',
    telephone: '+353870000000',
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00'
    }
  };
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Website Design',
    provider: {
      '@type': 'LocalBusiness',
      name: 'ai.web'
    },
    areaServed: {
      '@type': 'Country',
      name: 'Ireland'
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Website Design Packages',
      itemListElement: [{
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Dublin Launch Package'
        },
        price: '249.00',
        priceCurrency: 'EUR'
      }]
    }
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'How much does a website cost in Dublin?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Most Dublin web design agencies charge between €1,000 and €3,000. Our package is just €249 one-time because we use efficient AI-powered tools.'
      }
    }, {
      '@type': 'Question',
      name: 'Do you build websites for specific industries in Ireland?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes! We specialise in websites for electricians, plumbers, restaurants, barbers, hotels, and all local trades in Dublin and across Ireland.'
      }
    }, {
      '@type': 'Question',
      name: 'Can you help my Dublin business rank on Google?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Absolutely. All our websites are built with an SEO-friendly structure, fast loading speeds, and mobile responsiveness.'
      }
    }, {
      '@type': 'Question',
      name: "What's included in the €249 package?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Full custom website build, mobile responsive design, contact form, WhatsApp integration, Google Maps, basic analytics, 1-year Hobby plan ($180 value), 100 monthly AI editing requests, and up to 3 rounds of revisions.'
      }
    }]
  };
  return <div style={{
    display: 'none'
  }} data-id="element-578">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(localBusinessSchema)
    }} data-id="element-579" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(serviceSchema)
    }} data-id="element-580" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} data-id="element-581" />
    </div>;
}